import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,{ref:"inputRef",class:{ 'icon-disabled': _vm.disabled },attrs:{"value":_vm.formattedValue,"label":_vm.label,"disabled":_vm.disabled,"error-messages":_vm.errorMessage,"type":"text"},on:{"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }